module.exports = __webpack_public_path__ + "static/media/Company-1.4bac69b8.jpg";